"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sign = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var sign_1 = require("../../model/sign");
var service_1 = require("../../../library/base/service");
var Sign = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(Sign, _super);
    function Sign() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '签到接口';
        _this.code = '101053';
        _this.desc = '签到接口';
        _this.requestParams = new sign_1.SignRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return Sign;
}(service_1.BaseService));
exports.Sign = Sign;
//# sourceMappingURL=sign.js.map